import { render, staticRenderFns } from "./CoCardUpgrade.vue?vue&type=template&id=5db19ac2&"
import script from "./CoCardUpgrade.vue?vue&type=script&lang=ts&"
export * from "./CoCardUpgrade.vue?vue&type=script&lang=ts&"
import style0 from "./CoCardUpgrade.vue?vue&type=style&index=0&id=5db19ac2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports